// extracted by mini-css-extract-plugin
module.exports = {"switch":"styles_switch__34Bcs","button":"styles_button__1EsJF","lodaing":"styles_lodaing__3UApa"};